module.exports = __webpack_public_path__ + "static/media/closeButton.46485a23.svg";